export function partnerType(state = 'app', action) {
  switch (action.type) {
    case "PARTNER_TYPE":
      return action.status;
    default:
      return state;
  }
}
